module.exports = __webpack_public_path__ + "img/logo_board.43fdd36d.svg";